module.exports = __webpack_public_path__ + "img/dropshipping-warehouse.22cba218.svg";